// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe7c5169","239":"7b442f78","455":"e901e474","488":"b6f8d01a"}[chunkId] + ".chunk.js";
};